module.exports = "https://www.gc-pro.gnp.com.mx/1947bfc6ca49658302da011fc5d2e98d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-tarjeta-circulacion.svg
// module id = 1807
// module chunks = 0